"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.padding = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _tokens = require("./tokens");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var padding = {
  styles: function styles() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref.target,
        all = _ref.all,
        x = _ref.x,
        y = _ref.y,
        top = _ref.top,
        right = _ref.right,
        bottom = _ref.bottom,
        left = _ref.left;

    var shared = {
      target: target,
      tokenKey: 'spacing'
    };
    return {
      paddingTop: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'padding.top',
        fallback: [top, y, all]
      })),
      paddingRight: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'padding.right',
        fallback: [right, x, all]
      })),
      paddingBottom: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'padding.bottom',
        fallback: [bottom, y, all]
      })),
      paddingLeft: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'padding.left',
        fallback: [left, x, all]
      }))
    };
  },
  tokens: function tokens() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref2.target,
        all = _ref2.all,
        x = _ref2.x,
        y = _ref2.y,
        top = _ref2.top,
        right = _ref2.right,
        bottom = _ref2.bottom,
        left = _ref2.left;

    var shared = {
      target: target,
      tokenKey: 'spacing'
    };
    return {
      padding: {
        top: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'padding.top',
          fallback: [top, y, all]
        })),
        right: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'padding.right',
          fallback: [right, x, all]
        })),
        bottom: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'padding.bottom',
          fallback: [bottom, y, all]
        })),
        left: (0, _tokens.generateTokenFn)(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'padding.left',
          fallback: [left, x, all]
        }))
      }
    };
  }
};
exports.padding = padding;